import { FC } from 'react';
import Select from 'react-select';
import { useTranslate } from 'hooks/useTranslate';

import CustomAsyncSelect from 'modules/_shared/components/CustomAsyncSelect';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import TradingOfferOperationsTable from './components/TradingOfferOperationsTable';
import { useTradingOfferOperations } from './context/TradingOfferOperationsContext';

const TradingOfferOperations: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useTradingOfferOperations();

  const showPagination =
    data.tradingOfferOptions && data.totalTradingOfferOperations > 10;

  return (
    <div className="card card-bordered">
      <div className="card-inner">
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
          <div className="row w-100">
            {data.isPartnerView ? (
              <div className="col-12 col-md-6 mb-2">
                <Select
                  className="react-select react-select-lg"
                  placeholder={t('FilterByType')}
                  options={data.tradingOfferTypeOptions}
                  onChange={actions.handleChangeTradingOfferTypeOption}
                  isClearable
                />
              </div>
            ) : (
              <>
                <div className="col-12 col-md-6 mb-2">
                  <div className="flex-grow-1">
                    <CustomAsyncSelect
                      id="class-select-input"
                      value={data.selectedTradingOfferOption}
                      onChange={actions.handleChangeTradingOfferOption}
                      onFetchData={actions.handleSearchTradingOffer}
                      placeholder={t('SearchTradingOfferToFilter')}
                      minimumInputLength={1}
                      noDataLabelKey="NoOffersHaveBeenFound"
                      loadingLabelKey="LoadingOffers"
                      errorLabelKey="ErrorLoadingOffers"
                      defaultOptions={data.tradingOfferOptions}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 mb-2">
                  <Select
                    className="react-select react-select-lg"
                    placeholder={t('FilterByStatus')}
                    options={data.statusOptions}
                    onChange={actions.handleChangeStatusOption}
                    isClearable
                  />
                </div>
              </>
            )}
          </div>
        </div>

        <TradingOfferOperationsTable />

        {showPagination && (
          <div className="mx-2">
            <TablePagination
              defaultPage={data.page}
              totalRows={data.totalTradingOfferOperations || 0}
              showRowsPerPageOptions={false}
              onChangePage={actions.handleChangePage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TradingOfferOperations;
